export default "__VITE_ASSET__zPo02UXF__"